import { SPage } from "servisofts-component";
import nuevotutorial from "./nuevotutorial";
import tutoriales from "./tutoriales";
import musculo from "./musculo";
import musculoRoot from "./musculo/lista";
//const model = Model.popup_inicio;
export const Parent = {
    name: "tutoriales",
    path: `/marketing/tutoriales`,
    //model
}
export default SPage.combinePages(Parent.name, {
    // "": tutoriales,
    "": musculoRoot,
    ...musculo,
    "crear": nuevotutorial
})
